module.exports = __webpack_public_path__ + "static/result_yangyang-d05198c56e65ef854bec7efc70f61fa0.png";